import React from 'react';
import { TextInput as TextInputBase, MaskInput } from '@sravni/react-design-system';
import { ErrorTextWrapper } from '../common';
import { MASKS } from '../../../constants';

type Props = React.ComponentProps<typeof TextInputBase> & {
    errorMessage: React.ReactNode | undefined;
};

export const MonthInput = React.forwardRef<HTMLInputElement, Props>((props, ref) => {
    const { errorMessage, label, onChange: onChangeProp, ...other } = props;

    const onChange: React.ComponentProps<typeof MaskInput>['onChange'] = (value) => {
        if (onChangeProp) {
            const customEvent = { target: { value, name: props.name }, currentTarget: { value, name: props.name } };
            onChangeProp(customEvent as React.ChangeEvent<HTMLInputElement>);
        }
    };

    return (
        <ErrorTextWrapper errorText={errorMessage}>
            <MaskInput
                ref={ref}
                inputMode="numeric"
                mask={MASKS.MONTH}
                label={label ? label : undefined}
                {...other}
                onChange={onChange}
                invalid={Boolean(errorMessage)}
            />
        </ErrorTextWrapper>
    );
});

MonthInput.displayName = 'MonthInput';
